<template>
  <tile class="opc-zmone opc-zmone--delta" :class="{
    'opc-zmone-delta-modal': $context.is.modalDelta
  }">
    <PlanDetail v-show="false" ref="planDetail" />
    <foldable
      v-model="isExpanded"
      :title="title"
      :arrow="canExpand"
      :edit="canExpand"
      :isRemoveWrapAriaLabelledby="true"
    >
      <div slot="head">
        <div class="opc-zm-base-card__head">
          <div class="opc-zm-base-card__head-left">
            <img class="opc-zm-base-card__logo" :src="logo" :alt="title" />
          </div>
          <div class="opc-zm-base-card__head-right">
            <h2 class="opc-zm-base-card__name text-capitalize">
              {{ title }}
              <i class="zm-icon-success main-icon"></i>
            </h2>
            <div class="opc-zm-base-card__collapse" v-if="isExpanded && $context.is.modal">
              <zm-button data-testid="checkout-button-136" class="opc-zm-base-card__link" type="link" @click="viewCurrent">
                {{ $t('billing.delta.cur_plan_detail') }}
              </zm-button>
            </div>
            <div class="opc-zm-base-card__collapse opc-zm-base-card__collapse--reset" v-if="!isExpanded && formPlan">
              {{ expandedPlanDesc }}
            </div>
          </div>
        </div>
      </div>
      <div class="opc-zmone__main">
        <zm-form ref="zmoneForm" label-position="top" class="opc-config-form">
          <zm-form-item>
            <template>
              <template v-if="$context.is.modal">
                <p class="opc-zmone__form-label" slot="label">{{ $t('billing.delta.buy_more_licenses') }}</p>
                <div class="opc-zmone__form-modal-tips">
                  <span>{{ deltaCurUserTipsForModal }}</span>
                </div>
              </template>
              <template v-else>
                <p class="opc-zmone__form-label" slot="label">{{ $t('billing.delta.add_user') }}</p>
                <div class="opc-zmone__form-modal-tips">
                  <span>{{ $t('billing.delta.cur_users', { X: boughtMeetingPlan.cartInfo.selected_number }) }}</span>
                  <zm-button data-testid="checkout-button-137" class="opc-zm-base-card__link" type="link" @click="viewCurrent">
                    {{ $t('billing.delta.cur_plan_detail') }}
                  </zm-button>
                </div>
              </template>
            </template>
            <div class="opc-zmone__form-input-wrapper">
              <InputNumberWithPopover
                class="opc-zmone__quantity-selector"
                v-model="deltaForm.selectedNumber"
                size="large"
                controls-position="both"
                :min="1"
                :max="maxHost"
                :label="`${title} Select the number of users`"
                :decrease-tips="popUpDecreaseTips"
                :increase-tips="increaseTips"
              />
              <template v-if="$context.is.modal">
                <span class="opc-modal-tips-title">
                  {{ $t('billing.delta.new_licenses') }}
                </span>
                <span class="opc-modal-billing-cycle">
                  <inline-price :price="currentBillingCyclePrice.price"></inline-price>
                  <span class="opc-modal-cycle-info">
                    {{ currentBillingCyclePrice.unit }},
                    {{ getBillTextByCycle(currentEditPlan.billing_cycle) }}
                  </span>
                </span>
              </template>
            </div>
          </zm-form-item>
          <zm-form-item class="opc-config-form__last-item" v-if="!$context.is.modal">
            <zm-radio-group
              v-model="form.billingCycle"
              class="opc-card-radio"
              :aria-label="`${title} Billing Cycle`"
              @change="submitForm"
            >
              <zm-radio
                v-for="plan in currentPlans"
                data-testid="checkout-radio-138"
                :key="plan.billing_cycle"
                :label="plan.billing_cycle"
                :disabled="billingCycleDisabled(plan)"
                class="opc-zmone__radio"
              >
                <p class="opc-zmone__radio-title text-capitalize">
                  {{ $t(`billing.billing_cycle.${plan.billing_cycle}`) }}
                </p>
                <p class="opc-product-price-container" tabindex="-1">
                  <span
                    v-for="(value, key, index) in getPriceOfMonth(plan.amount, plan.billing_cycle, { forceDiff: true })"
                    :key="index"
                    :class="[
                      `opc-product-price-container__${key}`,
                      useSmallSize(value) ? 'opc-product-price-container__small' : '',
                    ]"
                    :style="value.symbol && value.place === 'end' ? { order: 1 } : {}"
                  >
                    {{ value.symbol ? value.symbol : value }}
                  </span>
                </p>
                <p
                  class="opc-zmone__radio-price-unit opc-price-bill-text"
                 >
                <span v-html="getMergedBilledText(plan.billing_cycle, plan.amount)"></span><priceVATTip />
                </p>
              </zm-radio>
            </zm-radio-group>
          </zm-form-item>
          <preview-payment />
        </zm-form>
      </div>
    </foldable>
  </tile>
</template>

<script>
import { pageConfig } from '@/common/service/page-config';
import { ZOOM_MEETING_SUB_TYPES } from '../common/utils';
import edit from './edit.vue';
import { mapGetters } from 'vuex';
import { plansof } from '@/utils/chain';
import offerNotEligible from '@/components/offer-not-eligible';
import { categories } from '../cart.vue';
import { PLAN_PRICE_CHANGE_UTILS } from '@/common/priceChange';
import { PREVIEW_ACTION_TYPES } from '@/store/modules/preview';
import { BILLING_CYCLE, planTypes } from '@/common/constants';
import PlanDetail from '../cart.vue';
import InlinePrice from '@/components/inline-price.vue';
import ViewCurrentDialog from '@/components/view-current-dialog';

import { getPlanUnitWithCycle, planUnitMap, getBillTextByCycle } from '@/common/product-unit';
import deltaCondition from '@/plans/ZOOM_MEETING/mixin/delta-condition';
import { ServiceConfirm } from '@/components/common/service-dialog/confirm';

export default {
  mixins: [edit, deltaCondition],
  created() {
    this.viewCurrentDialog = new ServiceConfirm(ViewCurrentDialog);
  },
  data() {
    return {
      deltaForm: {
        selectedNumber: 1,
      },
    };
  },
  computed: {
    ...mapGetters(['preloadCartInfo', 'planMapFlatRaw', 'hasPendingRequest', 'boughtPlans', 'getSelectedPlans']),
    deltaCurUserTipsForModal() {
      const userQuantity = this.boughtMeetingPlan.cartInfo.selected_number;

      if (this.form.category === ZOOM_MEETING_SUB_TYPES.PRO) {
        return userQuantity > 1 ? this.$t('billing.delta.cur_users_modal_multiple', { X: userQuantity })
          : this.$t('billing.delta.cur_users_modal_single');
      }

      return this.$t('billing.delta.cur_users', { X: userQuantity });
    },
    currentEditPlan() {
      return this.currentPlans.find((p) => p.plan_code === this.oldPlanCode);
    },
    currentBillingCyclePrice() {
      const unit = this.$context.is.modalDelta ? planUnitMap.license : planUnitMap.user;
      let amount = this.currentEditPlan.amount / 100;

      if (this.currentEditPlan.billing_cycle === BILLING_CYCLE.ANNUAL_TERM_MONTHLY) {
        amount = amount / this.currentEditPlan.cycleValue;
      }

      return {
        price: amount.toFixed(2),
        unit: getPlanUnitWithCycle(this.currentEditPlan.billing_cycle, unit),
      };
    },
    mimicProratedCharges() {
      const plan = plansof(this.getSelectedPlans).type(planTypes.ZOOM_MEETING).get(0); // this is edit flow
      const $vm = this.$refs.planDetail;
      const deltaAmount = $vm?.mx_price_delta?.(plan) ?? 0;
      const deltaLicense = $vm?.mx_license_delta?.(plan) ?? 0;
      const boughtLicense = $vm?.mx_license_bought?.(plan) ?? 1;
      // getters.getTaxTotalAmount is polluted by INR checkout
      const getTaxTotalAmount = this.$store.state.Tax.taxes.reduce((acc, x) => {
        const planTax = x.tax.reduce((acc, y) => {
          return acc + y.taxAmount;
        }, 0);
        return acc + planTax;
      }, 0);
      const proratedTax = (getTaxTotalAmount * deltaLicense) / (deltaLicense + boughtLicense);
      const totalAmount = deltaAmount + proratedTax;
      return {
        amount: 0,
        taxAmount: proratedTax,
        totalAmount,
      };
    },
    maxHost() {
      return this.maxHostInfo.max;
    },
    maxHostInfo() {
      if (this.$context.is.modal && this.form.category === ZOOM_MEETING_SUB_TYPES.PRO) {
        return {
          max: 99,
          tips: this.$t('billing.error.cant_add_100'),
        };
      }
      return {
        max: 9999,
        tips: '',
      };
    },
    expandedPlanDesc() {
      const quantity = this.deltaForm.selectedNumber;
      const amount = this.$money(this.formPlan ? this.formPlan.amount : 0);
      const unitDesc = this.getPlanUnitWithCycle(this.form.billingCycle);

      return this.$context.is.modalDelta ?
        `${this.$t('billing.unit.license', [quantity])} •  ${amount}${unitDesc}`
        : this.$t('billing.zone.desc1', [ quantity, amount, unitDesc ]);
    }
  },
  components: {
    PlanDetail,
    InlinePrice,
  },
  watch: {
    mimicProratedCharges: {
      deep: true,
      async handler() {
        // todo can use implemented prorated price, remove this watch
        if (this.$context.is.modalDelta) return;

        this.$nextTick(() => {
          this.$store.dispatch(PREVIEW_ACTION_TYPES.resetProratedCharges);
          this.$store.commit('setProratedChargeAmount', this.mimicProratedCharges.amount);
          this.$store.commit('setProratedChargeTaxAmount', this.mimicProratedCharges.taxAmount);
          this.$store.commit('setProratedChargeTotalAmount', this.mimicProratedCharges.totalAmount);
        });
      },
    },
    'deltaForm.selectedNumber': {
      handler() {
        this.$nextTick(() => {
          this.updateSelectedNumber();
        });
      },
    },
  },
  methods: {
    getPlanUnitWithCycle(billingCycle) {
      return getPlanUnitWithCycle(billingCycle, this.$context.is.modalDelta ? planUnitMap.license : planUnitMap.user);
    },
    init() {
      // cart builder plan planCode is not accurate due to different billing cycle that sales rep may choose
      // we need to get added quantity from the cart builder plan of current edit type
      const preCondition = this.getDeltaPreCondition();
      if (!preCondition) return offerNotEligible();
      // keep original cartid build delta logic
      if (this.$context.is.delta) {
        // disable scenarios with incidental plans, e.g. US & CA Audio Conferencing
        if (this.getSelectedPlans?.length > 1) {
          return offerNotEligible();
        }
      }

      const oldPlanCode = pageConfig.oldPlanCode;
      const currentEditPlan = this.planMapFlatRaw.find((x) =>
        [oldPlanCode, PLAN_PRICE_CHANGE_UTILS.getOtherPlanCodeForPriceChange(oldPlanCode)].includes(x.plan_code),
      );
      const editPlanType = currentEditPlan?.type;
      const editPlanCategory = currentEditPlan?.category;
      if (!editPlanType || !editPlanCategory) return;
      const plansOfEditType = plansof(this.planMapFlatRaw).type(editPlanType).category(editPlanCategory).get();
      const allPlanCodesOfEditType = plansOfEditType.map((x) => x.plan_code);
      const changedPriceCodes = allPlanCodesOfEditType.map((planCode) =>
        PLAN_PRICE_CHANGE_UTILS.getOtherPlanCodeForPriceChange(planCode),
      );
      // * addQty case
      if (this.$context.is.modal && this.$context.is.addQty) {
        const boughtMeetingPlanSelectedNumber = this.boughtMeetingPlan?.cartInfo?.selected_number;
        // ! note currentEditPlan here is the current edit plan(selected Plan), which is not same as the currentEditPlan in vuex (boughtPlans).
        const currentEditPlanSelectedNumber = this.currentEditPlan?.cartInfo?.selected_number;
        const addQty = currentEditPlanSelectedNumber - boughtMeetingPlanSelectedNumber;
        this.deltaForm.selectedNumber = Number(addQty) > 0 ? Number(addQty) : 1;
      } else {
        const cartPlans = this.preloadCartInfo?.orderData?.planList;
        const targetPlan = cartPlans?.find((x) =>
          [...changedPriceCodes, ...allPlanCodesOfEditType].includes(x.planCode),
        );
        if (!targetPlan) {
          const allPlansOfEditType = plansof(this.planMapFlatRaw).type(editPlanType).get();
          const offeredPlanCategory =
            allPlansOfEditType.find((x) => {
              const cartPlanCodes = cartPlans.map((x) => x.planCode);
              const planCode = x.plan_code;
              const priceChangePlanCode = PLAN_PRICE_CHANGE_UTILS.getOtherPlanCodeForPriceChange(planCode);
              return cartPlanCodes.includes(x.plan_code) || cartPlanCodes.includes(priceChangePlanCode);
            })?.category ?? '';
          return offerNotEligible(
            offeredPlanCategory &&
              `${this.$t('billing.delta.offer_exclusive_to', [this.$t(categories[offeredPlanCategory] ?? '')])}`,
          );
        }
        this.deltaForm.selectedNumber = Math.max(targetPlan.quantity, 1);
      }
      this.updateSelectedNumber();
    },
    updateSelectedNumber() {
      const selectedNumber = (this.boughtMeetingPlan?.cartInfo?.selected_number ?? 0) + this.deltaForm.selectedNumber;
      this.form.selectedNumber = selectedNumber;
      this.submitForm(selectedNumber);
    },
    async viewCurrent() {
      this.$tracking.buyInteraction('view current plan details selected', this.title);
      this.viewCurrentDialog.confirm({ planType: planTypes.ZOOM_MEETING });
    },
    getBillTextByCycle(billingCycle) {
      if (billingCycle === BILLING_CYCLE.ANNUAL_TERM_MONTHLY) {
        return `${this.$t('billing.bill_12_payments')}, ${getBillTextByCycle(billingCycle)}`;
      }
      return getBillTextByCycle(billingCycle);
    },
  },
  mounted() {
    setTimeout(this.init, 0);
  },
};
</script>

<style lang="scss">
@import '@zoom/billing-responsive/styles/responsive.scss';
.opc-zmone--delta {
  .opc-card-radio {
    @include media(desktop) {
      width: 50%;
    }
    .opc-price-save-count {
      display: none;
    }
    .zm-radio__label.is-checked {
      .zm-radio__label--inner {
        border: 1px solid #b8b8c4;
      }
      &:after {
        display: none;
      }
    }
    .zm-radio__label:not(.is-checked) {
      display: none;
    }
    :has(.zm-radio__label:not(.is-checked)) {
      display: none;
    }
  }
  .opc-zmone__main {
    .opc-config-form {
      .opc-zmone__form-modal-tips {
        display: flex;
        justify-content: start;
        align-items: baseline;
        .opc-zm-base-card__link {
          margin-left: 4px;
        }
      }
      .opc-zmone__form-input-wrapper {
        display: flex;
        align-items: baseline;
        margin-top: 12px;
        .opc-zmone__quantity-selector {
          margin-top: 0;
        }
      }
    }
    .opc-modal-tips-title {
      font-size: 16px;
      font-weight: 600;
      margin: 0 8px;
      flex-shrink: 0;
    }
    .opc-modal-billing-cycle {
      margin-left: 40px;
      display: inline-flex;
      flex-wrap: nowrap;
      gap: 8px;
      .opc-modal-cycle-info {
        color: #6e7680;
      }
    }
  }
}

.opc-zmone--delta {
  &.opc-zmone-delta-modal {
    .opc-zm-base-card__name {
      @include media(mobile, tablet) {
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 150%; /* 30px */
      }
    }

    .opc-zm-base-card__collapse {
      margin-top: 0px;
    }
  }
}

</style>
